/* import __COLOCATED_TEMPLATE__ from './sq-field-input-currency.hbs.js'; */
// `SqFieldInputCurrencyComponent` is a variation on sq-input-currency, a text field input with localized formatting
// for currency. Text is formatted to ,look like currency to the user, and a string without formatting is bound to the value.
// For inputs that need the money object, use SqFieldInputMoneyComponent Instead.
//
// Like other `SqFieldInput` components, the input is technically standalone, but is
// really intended to be nested inside a Form Field block component. The two components
// communicate with each other over event handling and auto fill in placeholder if you don't add one.
//
// Parameters to the component can follow any standard Ember Input helper. Not really anything proprietary or new here.
//
// Sass dependencies at:
// `app/assets/stylesheets/bridgeport/components/form-elements/formfield/_formfield.sass`
//
// ## Example
//
// {{sq-field-input-currency fieldName=name}}

/* eslint square/no-restricted-files:"off" -- unscoped components in this folder are discouraged */
import FieldElementSupport from '@square/glass-ui/utils/field-element-support';
import SqInputCurrencyComponent from './sq-input-currency';
export default class SqFieldInputCurrency extends SqInputCurrencyComponent.extend(FieldElementSupport) {}